<script setup lang="ts">
  import { IconListCompleted, Button } from "@ui-kit";
  import { useTimer } from "@src/hooks";
  import { default as Wrapper } from "./Wrapper.vue";

  const emit = defineEmits<{ (e: "click:more"): void; (e: "click:cancel"): void }>();

  const { timer } = useTimer(2, () => emit("click:more"));
</script>

<template>
  <Wrapper :title="$t('Hard tag успешно подготовлен')" :subtitle="$t('Товар готов к продаже')" data-testid="alarming-success">
    <template #icon>
      <IconListCompleted />
    </template>
    <template #buttons>
      <Button variant="secondary" @click="emit('click:more')" data-testid="alarming-btn-more">
        {{ $t("Алармировать еще") + " (" + timer + ")" }}
      </Button>
      <Button @click="emit('click:cancel')" data-testid="alarming-btn-main">{{ $t("На главную") }}</Button>
    </template>
  </Wrapper>
</template>
